/**
 * Launches a download in the browser
 * @param blob
 * @param fileName
 */
export const saveBlobFile = (blob: Blob, fileName: string) => {
    const a: HTMLAnchorElement | any = document.createElement('a')
    const url = window.URL.createObjectURL(blob)
    a.href = url
    a.download = fileName
    document.body.appendChild(a)
    a.click()
    window.URL.revokeObjectURL(url)
    a.remove()
}
